

//Notes that this class shouldn't be kept in ClassRegistry because of circular dependence;
export default class ClassTypes{

	//Note that once you choose the string value here, it shouldn't change or all the indexes will break
	//and loading will break;
	static CHAMPION="Champion";
	static SKILL_ORDER="SkillOrder";
	static PLAYER="Player";
	static SIMULATION="Simulation";
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/framework/ClassTypes.ts